import React from 'react'
import PropTypes from 'prop-types'
import managerApi from 'app/pipelines/checkout/manager'
const Trans = require('app/components/trans/Trans')

export default class CloseButton extends React.PureComponent {
  static get propTypes () {
    return {
      label: PropTypes.any
    }
  }

  static get defaultProps () {
    return {
      label: translate('Shop videre')
    }
  }

  close () {
    managerApi.close.dispatch()
  }

  render () {
    return (
      <button className='close-button' onClick={this.close.bind(this)}>{this.props.label}</button>
    )
  }
}
